import React, { useEffect, useState } from 'react'
import api from '../api'
import { Plus, Ticket, Wand2 } from 'lucide-react'
import { Card, PageHeader, Button, Input, Field, Modal, ModalHeader, Alert, Select, Label } from '../components/ui'

// Generator rate-limit -- DUPLIKAT SENGAJA dari PaketLangganan.jsx (bukan diimpor bersama), sama
// pola dgn halaman2 CRUD lain di app ini yg masing2 berdiri sendiri. Field & format string persis
// sama (native Mikrotik-Rate-Limit) krn dipakai atribut yg sama di authorize_reply_query RADIUS.
function RateRow({ label, note, up, unitUp, down, unitDown, onUp, onUnitUp, onDown, onUnitDown }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <Label>{label}</Label>
      {note && <div style={{ fontSize: 11, color: 'var(--text-faint)', marginTop: -3, marginBottom: 6 }}>{note}</div>}
      <div className="grid-2" style={{ gap: 10 }}>
        <div>
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 4 }}>Upload</div>
          <div style={{ display: 'flex', gap: 6 }}>
            <Input type="number" min="0" step="any" value={up} onChange={e => onUp(e.target.value)} placeholder="0" />
            <Select value={unitUp} onChange={e => onUnitUp(e.target.value)} style={{ width: 84, flexShrink: 0 }}>
              <option value="M">Mbps</option>
              <option value="k">Kbps</option>
            </Select>
          </div>
        </div>
        <div>
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 4 }}>Download</div>
          <div style={{ display: 'flex', gap: 6 }}>
            <Input type="number" min="0" step="any" value={down} onChange={e => onDown(e.target.value)} placeholder="0" />
            <Select value={unitDown} onChange={e => onUnitDown(e.target.value)} style={{ width: 84, flexShrink: 0 }}>
              <option value="M">Mbps</option>
              <option value="k">Kbps</option>
            </Select>
          </div>
        </div>
      </div>
    </div>
  )
}

function defaultGen() {
  return { maxUp: '', maxUpUnit: 'M', maxDown: '', maxDownUnit: 'M' }
}

function parseValuePart(token) {
  const m = String(token || '').trim().match(/^([\d.]+)\s*(M|k)?$/i)
  if (!m || Number(m[1]) === 0) return { num: '', unit: 'M' }
  return { num: m[1], unit: (m[2] || '').toLowerCase() === 'k' ? 'k' : 'M' }
}

// Rate limit voucher disederhanakan (2026-07-25) -- cuma Max Limit up/down (tanpa burst/threshold/
// priority spt Paket Langganan), krn kasus pakai voucher hotspot jauh lebih simpel dari PPPoE
// pelanggan tetap. Format tetap string Mikrotik-Rate-Limit standar (bisa 1 token "4M/4M" saja).
function parseRateLimit(str) {
  try {
    const tokens = String(str || '').trim().split(/\s+/)
    if (!tokens[0]) return null
    const [up, down] = tokens[0].split('/')
    const a = parseValuePart(up), b = parseValuePart(down)
    return { maxUp: a.num, maxUpUnit: a.unit, maxDown: b.num, maxDownUnit: b.unit }
  } catch { return null }
}

function formatPart(num, unit) {
  const n = Number(num)
  if (!num || !n) return '0'
  return `${n}${unit === 'k' ? 'k' : 'M'}`
}

function composeRateLimit(g) {
  return `${formatPart(g.maxUp, g.maxUpUnit)}/${formatPart(g.maxDown, g.maxDownUnit)}`
}

// Durasi disimpan sbg menit (dibaca authorize_reply_query RADIUS: durasi_menit * 60 = Session-
// Timeout), tapi admin input lbh nyaman dlm jam/hari -- konversi 2 arah di sini.
const UNIT_MENIT = { menit: 1, jam: 60, hari: 1440 }
function durasiKeMenit(angka, unit) { return Math.round(Number(angka || 0) * (UNIT_MENIT[unit] || 1)) }
function menitKeDurasi(menit) {
  if (!menit) return { angka: '', unit: 'jam' }
  if (menit % 1440 === 0) return { angka: menit / 1440, unit: 'hari' }
  if (menit % 60 === 0) return { angka: menit / 60, unit: 'jam' }
  return { angka: menit, unit: 'menit' }
}

// durasi_menit === 0 -- lihat catatan authorize_reply_query di radius/config/queries.conf soal
// kenapa Session-Timeout sengaja tidak dikirim sama sekali utk paket ini.
function labelDurasi(p) {
  if (p.durasi_menit === 0) return 'Selamanya'
  const d = menitKeDurasi(p.durasi_menit)
  return `${d.angka} ${d.unit}`
}

function defaultForm() {
  return { nama: '', selamanya: false, durasiAngka: '', durasiUnit: 'jam', rate_limit: '', harga_jual: '', urutan: 0 }
}

export default function PaketVoucher() {
  const [data, setData] = useState([])
  const [modal, setModal] = useState(false)
  const [form, setForm] = useState(defaultForm())
  const [editId, setEditId] = useState(null)
  const [error, setError] = useState('')
  const [genModal, setGenModal] = useState(false)
  const [gen, setGen] = useState(defaultGen())

  useEffect(() => { load() }, [])

  async function load() {
    const res = await api.get('/paket-voucher')
    setData(res.data)
  }

  function bukaTambah() {
    setForm({ ...defaultForm(), urutan: data.length + 1 })
    setEditId(null); setError(''); setModal(true)
  }

  function bukaEdit(p) {
    const selamanya = p.durasi_menit === 0
    const d = selamanya ? { angka: '', unit: 'jam' } : menitKeDurasi(p.durasi_menit)
    setForm({ nama: p.nama, selamanya, durasiAngka: d.angka, durasiUnit: d.unit, rate_limit: p.rate_limit || '', harga_jual: p.harga_jual, urutan: p.urutan })
    setEditId(p.id); setError(''); setModal(true)
  }

  async function simpan() {
    if (!form.nama.trim()) { setError('Nama paket wajib diisi'); return }
    const durasi_menit = form.selamanya ? 0 : durasiKeMenit(form.durasiAngka, form.durasiUnit)
    if (!form.selamanya && !durasi_menit) { setError('Durasi wajib diisi'); return }
    try {
      const body = { nama: form.nama, durasi_menit, rate_limit: form.rate_limit, harga_jual: form.harga_jual, urutan: form.urutan }
      if (editId) await api.put(`/paket-voucher/${editId}`, { ...body, aktif: 1 })
      else await api.post('/paket-voucher', body)
      setModal(false); load()
    } catch (e) {
      setError(e.response?.data?.message || 'Gagal menyimpan')
    }
  }

  function bukaGenerator() {
    setGen(parseRateLimit(form.rate_limit) || defaultGen())
    setGenModal(true)
  }

  function terapkanGenerator() {
    setForm({ ...form, rate_limit: composeRateLimit(gen) })
    setGenModal(false)
  }

  async function nonaktifkan(id) {
    if (!window.confirm('Nonaktifkan paket voucher ini?')) return
    await api.delete(`/paket-voucher/${id}`)
    load()
  }

  const WARNA = ['#4f46e5', '#f72585', '#7c3aed', '#0ea5e9', '#10b981', '#f59e0b', '#4cc9f0', '#e11d48']

  return (
    <div>
      <PageHeader
        title="Paket Voucher"
        subtitle="Master data durasi & kecepatan voucher hotspot, dipakai saat generate voucher"
        actions={<Button icon={Plus} onClick={bukaTambah}>Tambah Paket</Button>}
      />

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 14 }}>
        {data.map((p, i) => {
          return (
            <Card key={p.id} style={{ padding: 18, opacity: p.aktif ? 1 : 0.5, display: 'flex', alignItems: 'flex-start', gap: 14 }}>
              <div style={{
                width: 46, height: 46, borderRadius: 11, flexShrink: 0,
                background: WARNA[i % WARNA.length],
                display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff'
              }}><Ticket size={20} /></div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{p.nama}</div>
                <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>{labelDurasi(p)}</div>
                {p.rate_limit && <div style={{ fontSize: 11, color: 'var(--text-faint)', marginTop: 2, fontFamily: 'monospace' }}>{p.rate_limit}</div>}
                <div style={{ fontSize: 13, color: 'var(--brand)', marginTop: 4, fontWeight: 600 }}>Rp {Number(p.harga_jual).toLocaleString('id-ID')}</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                <Button size="sm" variant="soft" onClick={() => bukaEdit(p)}>Edit</Button>
                {p.aktif && <Button size="sm" variant="danger-soft" onClick={() => nonaktifkan(p.id)}>Hapus</Button>}
              </div>
            </Card>
          )
        })}
      </div>

      {modal && (
        <Modal onClose={() => setModal(false)} width={420}>
          <ModalHeader title={editId ? 'Edit Paket Voucher' : 'Tambah Paket Voucher'} onClose={() => setModal(false)} />
          {error && <Alert type="error">{error}</Alert>}
          <Field label="Nama Paket *" style={{ marginBottom: 14 }}>
            <Input value={form.nama} onChange={e => setForm({ ...form, nama: e.target.value })} placeholder="1 HARI" />
          </Field>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14, fontSize: 13, cursor: 'pointer' }}>
            <input type="checkbox" checked={form.selamanya} onChange={e => setForm({ ...form, selamanya: e.target.checked })} />
            Aktif Selamanya (tanpa batas sesi -- cocok utk voucher member permanen)
          </label>
          {!form.selamanya && (
            <div className="grid-2" style={{ gap: 10, marginBottom: 14 }}>
              <Field label="Durasi *">
                <Input type="number" min="1" value={form.durasiAngka} onChange={e => setForm({ ...form, durasiAngka: e.target.value })} placeholder="1" />
              </Field>
              <Field label="Satuan">
                <Select value={form.durasiUnit} onChange={e => setForm({ ...form, durasiUnit: e.target.value })}>
                  <option value="menit">Menit</option>
                  <option value="jam">Jam</option>
                  <option value="hari">Hari</option>
                </Select>
              </Field>
            </div>
          )}
          <div style={{ marginBottom: 14 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
              <Label style={{ marginBottom: 0 }}>Mikrotik Rate Limit</Label>
              <Button type="button" size="sm" variant="soft" icon={Wand2} onClick={bukaGenerator}>Generator</Button>
            </div>
            <Input value={form.rate_limit} onChange={e => setForm({ ...form, rate_limit: e.target.value })} placeholder="1M/1M" style={{ fontFamily: 'monospace' }} />
          </div>
          <div className="grid-2" style={{ gap: 10, marginBottom: 22 }}>
            <Field label="Harga Jual (Rp) *">
              <Input type="number" value={form.harga_jual} onChange={e => setForm({ ...form, harga_jual: e.target.value })} placeholder="3000" />
            </Field>
            <Field label="Urutan Tampil">
              <Input type="number" value={form.urutan} onChange={e => setForm({ ...form, urutan: parseInt(e.target.value) || 0 })} />
            </Field>
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <Button variant="neutral" onClick={() => setModal(false)} style={{ flex: 1, justifyContent: 'center' }}>Batal</Button>
            <Button onClick={simpan} style={{ flex: 1, justifyContent: 'center' }}>Simpan</Button>
          </div>
        </Modal>
      )}

      {genModal && (
        <Modal onClose={() => setGenModal(false)} width={480}>
          <ModalHeader title="Generator Rate Limit" subtitle="Isi Max Limit, otomatis digabung jadi string rate-limit" onClose={() => setGenModal(false)} />
          <RateRow
            label="Max Limit" note="Batas kecepatan maksimal voucher ini"
            up={gen.maxUp} unitUp={gen.maxUpUnit} down={gen.maxDown} unitDown={gen.maxDownUnit}
            onUp={v => setGen({ ...gen, maxUp: v })} onDown={v => setGen({ ...gen, maxDown: v })}
            onUnitUp={v => setGen({ ...gen, maxUpUnit: v })} onUnitDown={v => setGen({ ...gen, maxDownUnit: v })}
          />
          <div style={{
            background: '#f8f8fb', border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)',
            padding: '10px 12px', fontSize: 11.5, fontFamily: 'monospace', color: 'var(--text-muted)',
            marginBottom: 20, wordBreak: 'break-all'
          }}>
            Preview: {composeRateLimit(gen)}
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <Button variant="neutral" onClick={() => setGenModal(false)} style={{ flex: 1, justifyContent: 'center' }}>Batal</Button>
            <Button onClick={terapkanGenerator} style={{ flex: 1, justifyContent: 'center' }}>Terapkan ke Rate Limit</Button>
          </div>
        </Modal>
      )}
    </div>
  )
}
